import React from 'react';
import { Container } from '@/components/container';
import { Toolbar, ToolbarHeading } from '@/layouts/demo1/toolbar';
import { FormattedMessage } from 'react-intl';
import { AgentWelcomeBox, AgentUpgradeBox, AgentReactivateButton } from './homebox';
import { useNavigate } from 'react-router';

const AgentsHome = () => {
  const navigate = useNavigate();
  const handleCreateNewAgent = () => {
    navigate('/agents/builder');
  }
  return (
    <Container>
      <Toolbar>
        <ToolbarHeading title={<FormattedMessage id="AGENTS.HOME.TITLE" />} />
    </Toolbar>
    <div className="flex flex-col items-center justify-center py-10 gap-6">
      <AgentWelcomeBox onCreate={handleCreateNewAgent} />
      <AgentUpgradeBox />
      <AgentReactivateButton />
    </div>
  </Container>
);
}
export { AgentsHome }; 